@if (loading) {
  <div class="loading-container">
    <mat-icon class="animate-spin text-[#979799]!">hourglass_empty</mat-icon>
  </div>
}
